import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  ClockCircleOutlined,
  ToolOutlined,
  ShoppingOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { theme } from 'antd';

interface MobileBottomNavProps {
  onMenuClick: () => void;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = theme.useToken();

  const navItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: '首页',
    },
    {
      key: '/worktime',
      icon: <ClockCircleOutlined />,
      label: '工时',
    },
    {
      key: '/equipment',
      icon: <ToolOutlined />,
      label: '设备',
    },
    {
      key: '/material',
      icon: <ShoppingOutlined />,
      label: '材料',
    },
    {
      key: 'more',
      icon: <MenuOutlined />,
      label: '更多',
      onClick: onMenuClick,
    },
  ];

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '60px', // Standard tab bar height
        background: 'rgba(255, 255, 255, 0.8)', // Semi-transparent white
        backdropFilter: 'blur(10px)', // Frosted glass effect
        WebkitBackdropFilter: 'blur(10px)', // Safari support
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 1001, // Ensure it's above other content
        paddingBottom: 'safe-area-inset-bottom', // iOS safe area
        boxShadow: '0 -1px 4px rgba(0,0,0,0.05)',
      }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.key || 
                        (item.key !== '/' && location.pathname.startsWith(item.key));
        
        const color = isActive ? token.colorPrimary : '#999';

        return (
          <div
            key={item.key}
            onClick={() => {
              if (item.onClick) {
                item.onClick();
              } else {
                navigate(item.key);
              }
            }}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              height: '100%',
              cursor: 'pointer',
              color: color,
              transition: 'all 0.3s ease',
            }}
          >
            <div style={{ fontSize: '20px', marginBottom: '2px' }}>{item.icon}</div>
            <div style={{ fontSize: '10px', fontWeight: isActive ? 500 : 400 }}>{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileBottomNav;
